import cardImg from "assets/img/myProjects/cardImg.png";
import React, { useState,useEffect,useCallback,useRef } from "react";
import api from "views/auth/Api";
import { Link } from "react-router-dom";
import NftCard from "components/card/NftCard";
import "./Myprojects.css"
import  { API_BASE_URL } from '../../../configs/AppConfig';
import { FILES_URL } from '../../../configs/AppConfig';
import { MdOutlineSchool } from "react-icons/md";
import { AiOutlineTeam } from "react-icons/ai";
import { RiTeamLine } from "react-icons/ri";
import CustomDropdown from "../../../components/Dropdown"
import { IoSearchSharp } from "react-icons/io5";
import { BiReset } from "react-icons/bi";
import Loader from "components/loader";


const MyProjects = () => {
  const [data , setData] = useState([]);
    const [subjects , setSubjects] = useState([]);
    const [subject , setSubject] = useState('');
    const [search , setSearch] = useState('');
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [searchValue , setSearchValue] = useState('');
    const [loading, setLoading] = useState(false);
    
  
  const limit = 20; 
  const subjectRef = useRef();

  const getdrop = async()=>{
    await api.get(`${API_BASE_URL}assigned-projects/dropdown`)
  .then(function (response) {
    console.log(response.data?.project,"subjectsubject")
      const subjectNames = [...new Set(response.data?.map(item => item.project?.subject))];
      setSubjects(subjectNames)
  }).catch(error => {
    console.log("handlesubmit error for blog get ", error)
  });
  }
  useEffect(()=>{ 
    getdrop();
  },[]);

  const getData = useCallback(async () => {
    setLoading(true);
    await api.get(`${API_BASE_URL}assigned-projects`,{
      params: { page, limit, search, subject },
  })
  .then(function (response) {
      setLoading(false);
        setData(response.data?.items)
        setTotalPages(response.data.totalPages);
  
  }).catch(error => {
    console.log("handlesubmit error for blog get ", error)
  });
  },[page, limit, search, subject])
  
  useEffect(()=>{ 
    getData();
  },[getData]);

  //                           All projects filters     //

 const newSubject = (e)=>{
  setSubject(e)
}

  return (
    <>
      <div className="studentsearch">
        <div className="search-devs" >
                  <div className="search-form">
                    <div className="searchImg"></div>
                    <input className="search-input" placeholder="Search here" 
                            type="text"
                            value={searchValue}
                            onChange={(e) => {
                              setSearchValue(e.target.value)}}
                              onKeyDown={(e) => {
            if (e.key === "Enter") {
              setSearch(e.target.value)}}}/>
         <span className="newSearchIcon" onClick={() =>setSearch(searchValue)}>
            <IoSearchSharp className="w-[25px] h-[25px]"/></span>
                     </div>
      <div className="w-[180px]">
      <CustomDropdown options={subjects}
       selectedd={newSubject}
       ref={subjectRef}
       type="Subject"/>
             </div>
              <div className="filterReq flex items-center" onClick={()=>{
                setSubject('');
                setSearch('');
                setSearchValue('');
                subjectRef.current.rest()
              }}>
                <BiReset className="addImg"/>
                <span className="ml-[5px]">Reset</span>
              </div>        
        </div>
        <h2 className="proMainH2 dark:text-white">Assigned Projects</h2>
      </div>
          <div className="projectsDesc">
            <div className="challangeslist">
              {/* <h3>New Challenges</h3> */}
              <div className="projects-continar">
                {loading ? <Loader loading={loading} /> : !data[0] && !loading ?  <span>NO Projects Available</span> : null}
                {data.map(project => <Link to={`/admin/my-projects/main${project.id}`}> 
                <div className="projectsCards">
                <div className="cardImg-Pro" style={{backgroundImage:`url(${FILES_URL}${project.project?.img?.url})`}}></div>
                <div className="cardInfo-Pro">
                    <h4 className="text-lg font-bold text-navy-700 capitalize h-[56px]">{project.project?.projectName}</h4>
                    <span className="mt-3 text-l font-bold capitalize ntfCrdSubject">{project.project?.subject}</span>
                    <p className="mt-1 text-sm font-medium text-gray-600 md:mt-2"> <b>Lesson :</b> {project.project?.lesson} </p>
                    <div className="assignDetails gradeProDev">
                <div className="clockIconDev">
                  <MdOutlineSchool className="gradesIcon"/>
                   <span>Grade {project.project?.grade}</span>
                </div>

                <div className="clockIconDev">
                  <RiTeamLine className="classIcon"/>
                   <span>Class {project.class.class}</span>
                </div>

                <div className="clockIconDev">
                  <AiOutlineTeam className="teamIcon"/>
                   <span>Team Size {project.teamSize}</span>
                </div>
                </div>
                  </div>
              </div> </Link>)}
              </div>
            </div>
          </div>
        {!data[0] ? null : <div className="flex items-center justify-center mt-6 mb-4 gap-3 bottom-0 ">
        <button
          className="px-4 py-2 bg-gray-200 rounded-lg disabled:opacity-50"
          disabled={page === 1}
          onClick={() => setPage((p) => p - 1)}
        >
          Previous
        </button>

        {[...Array(totalPages)].map((_, i) => (
          <button
            key={i}
            className={`min-w-[40px] px-3 py-2 rounded-lg ${
              page === i + 1
                ? "pagination-active"
                : "bg-gray-200 hover:bg-gray-300"
            }`}
            onClick={() => setPage(i + 1)}
          >
            {i + 1}
          </button>
        ))}
        <button
          className="px-4 py-2 bg-gray-200 rounded-lg disabled:opacity-50"
          disabled={page === totalPages}
          onClick={() => setPage((p) => p + 1)}
        >
          Next
        </button>
      </div>}
    
    </>
  );
};

export default MyProjects;
